"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioButton = exports.ClickableArea = exports.Circle = exports.Caption = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _palette = require("../../styles/palette");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
//helpers

//constants
var innerRadius = 6;
var outerRadius = 9;
var thickness = 1;
var RadioButton = exports.RadioButton = _styledComponents["default"].div.withConfig({
  displayName: "styles__RadioButton",
  componentId: "sc-17ue01p-0"
})(["", " ", ""], function (p) {
  return p.design === 'default' && (0, _styledComponents.css)(["", "{display:inline-flex;}", "{margin-left:8px;}"], ClickableArea, Caption);
}, function (p) {
  return p.design === 'fill-line' && (0, _styledComponents.css)(["", "{display:flex;padding:0 24px;&:hover{color:", ";}}", "{color:inherit !important;}", "{margin-left:10px;}"], ClickableArea, _palette.commonPalette.btnGreen, Circle, Caption);
});
var ClickableArea = exports.ClickableArea = _styledComponents["default"].div.withConfig({
  displayName: "styles__ClickableArea",
  componentId: "sc-17ue01p-1"
})(["align-items:center;cursor:pointer;height:", "px;", ""], function (_ref) {
  var height = _ref.height;
  return height ? height : 48;
}, function (p) {
  return p.disabled && (0, _styledComponents.css)(["cursor:default;opacity:0.5;pointer-events:none;"]);
});
var Circle = exports.Circle = _styledComponents["default"].div.withConfig({
  displayName: "styles__Circle",
  componentId: "sc-17ue01p-2"
})(["border-radius:50%;border:", "px solid ", ";height:", "px;padding:", "px;width:", "px;&::after{background:", ";border-radius:", "px;content:'';display:block;height:", "px;transition:0.2s transform ease;width:", "px;}", ""], thickness, _palette.commonPalette.borderGrey, 2 * outerRadius, outerRadius - innerRadius - thickness, 2 * outerRadius, _palette.commonPalette.btnGreen, innerRadius, 2 * innerRadius, 2 * innerRadius, function (p) {
  return p.checked ? "\n    color: ".concat(_palette.commonPalette.btnGreen, ";\n  ") : "\n    &::after {\n      transform: scale(0.1);\n      visibility: hidden;\n    }\n  ";
});
var Caption = exports.Caption = _styledComponents["default"].div.withConfig({
  displayName: "styles__Caption",
  componentId: "sc-17ue01p-3"
})(["font-size:14px;line-height:20px;"]);
//# sourceMappingURL=styles.js.map